export const BASE_PATH = 'https://db.yeki.rent/api/v1'.replace(/\/+$/, '');
export const APP_URL =
  window.location.protocol +
  '//' +
  window.location.hostname +
  ':' +
  window.location.port;

export const INFO_EMAIL = 'info@yeki.rent';
